import {
  BarChart3,
  Brain,
  LayoutDashboard,
  Receipt,
  MonitorSmartphone,
  Settings,
  TrendingUp,
  UserCircle,
  Users,
} from 'lucide-react'
import type { ComponentType } from 'react'
import type { DashboardMode } from '@/features/auth/dashboard-mode.ts'

export interface NavItem {
  to: string
  label: string
  icon: ComponentType<{ className?: string }>
}

const USER_NAV: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/models', label: 'Models', icon: Brain },
  { to: '/usage', label: 'Usage', icon: BarChart3 },
  { to: '/transactions', label: 'Transaksi', icon: Receipt },
  { to: '/profile', label: 'Profil', icon: UserCircle },
  // VIP Support is hidden from the menu for now. The route and page are still
  // there, so an existing bookmark keeps working and restoring it is one line.
]

const ADMIN_NAV: NavItem[] = [
  { to: '/admin/reports', label: 'Laporan', icon: TrendingUp },
  { to: '/admin/transactions', label: 'Transaksi', icon: Receipt },
  { to: '/admin/users', label: 'Pengguna', icon: Users },
  { to: '/admin/desktop-app', label: 'Aplikasi Desktop', icon: MonitorSmartphone },
  { to: '/admin/settings', label: 'Pengaturan', icon: Settings },
]

export function navItemsFor(mode: DashboardMode): NavItem[] {
  return mode === 'admin' ? ADMIN_NAV : USER_NAV
}
